import React from 'react';
import {useSelector} from "react-redux";
import {rolesConstants, statesConstants} from "mindsets-js-sdk";

export default function () {
    const me = useSelector(state => state.me);
    if (me && me.persona === rolesConstants.ROLE_TEACHER && me.school && me.school.country && me.school.state && statesConstants.STATES.hasOwnProperty(me.school.country) && statesConstants.STATES[me.school.country].hasOwnProperty(me.school.state)) {
        const term = Object.keys(statesConstants.TERMS).includes(me.school.country) ? statesConstants.TERMS[me.school.country] : 'State';

        return (
            <div className="flex-row user-info-field">
                <div className="user-info-field-label">{term}</div>
                <div>{statesConstants.STATES[me.school.country][me.school.state]}</div>
            </div>
        );
    }

    return null;
}
